
import './hd.scss';

interface Props {
    onClose: () => void;
}

export default function HDBCMiniGame(props: Props) {
    const { onClose } = props;
    return (
        <>
          <div className="hdTXCB">          
            <section className="hd-txcb">
                <div className="wrapper">
                    <div className="title">HƯỚNG DẪN CHƠI</div>
                    <div className="close" onClick={onClose}>
                        <img src={require(`assets/images/txcanban/statis/close.png`)} alt='' />
                    </div>
                    <div className="inner">
                        <div className="tblBottomScroll">
                            <div className="content">
                                <ul className='hd-baucua'>
                                    <li>1.	Trên bàn cược và trên 6 mặt của xúc xắc sẽ có 6 hình: Bầu, Cua, Tôm, Cá, Nai, Gà, mỗi người chơi có thể cược vào một hoặc nhiều hình,giới hạn đặt cược 50,000,000 vnđ trên mỗi loại (bầu, cua, tôm, cá, nai, gà).</li>
                                    <li>2.	Để bắt đầu lượt chơi Bầu Cua Mini, người chơi có thể đặt cược trước hoặc sau khi xóc xúc xắc và vẫn có thể tiếp tục cược thêm khi thời gian đếm ngược chưa kết thúc, khi hết thời gian hệ thống sẽ tự mở kết quả.</li>
                                    <li>3.	Để bắt đầu lượt chơi Bầu Cua Mini, người chơi phải đặt cược trước khi Xóc xúc xắc, sau khi xóc xong hệ thống sẽ tự mở kết quả.</li>
                                    <li>4.	Sau khi mở kết quả, nếu 1 trong 3 con xúc xắc xuất hiện hình mà người chơi đã cược thì người chơi sẽ thắng, tiền thắng sẽ là số lần hình (đã cược mà xuất hiện) nhân với tỷ lệ thắng và nhân với số tiền cược.</li>
                                </ul>
                                <div className="hd">
                                    <p>Ví dụ: Sau khi xóc, kết quả 3 viên xúc xắc là: Tôm , Tôm , Gà .</p>
                                    <ul>
                                        <li>1. Người chơi cược Gà, người chơi sẽ trúng thưởng 1 lần.</li>
                                        <li>2. Người chơi cược Tôm, người chơi sẽ trúng thưởng gấp 2 lần.</li>
                                        <li>3. Người chơi cược cả Tôm và Gà, người chơi sẽ trúng thưởng gấp 3 lần.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        </>
    );
}
